/**
 * iter733 — Extracted from SalesPage.jsx. Bulk-VAT toolbar that lets
 * an accountant retro-fit VAT (inclusive or exclusive) to selected
 * sales OR a date/branch-filtered slice. All testids preserved.
 */
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export function BulkVatToolbar({
  bulkVatMode,
  setBulkVatMode,
  selectedSaleIds,
  setSelectedSaleIds,
  sales,
  bulkVatRate,
  setBulkVatRate,
  bulkVatInclusive,
  setBulkVatInclusive,
  bulkSkipExisting,
  setBulkSkipExisting,
  bulkFilterBranch,
  setBulkFilterBranch,
  bulkFilterStart,
  setBulkFilterStart,
  bulkFilterEnd,
  setBulkFilterEnd,
  branches,
  onSelectAll,
  onApply,
}) {
  return (
    <div className="mb-3">
      <div className="flex items-center gap-2 flex-wrap">
        <Button
          size="sm"
          variant={bulkVatMode ? 'default' : 'outline'}
          onClick={() => { setBulkVatMode(!bulkVatMode); setSelectedSaleIds(new Set()); }}
          className="h-8 text-xs rounded-full"
          data-testid="sales-bulk-vat-toggle"
        >
          {bulkVatMode ? 'Cancel Bulk' : 'Bulk VAT Update'}
        </Button>
        {bulkVatMode && (
          <>
            <Button size="sm" variant="outline" onClick={onSelectAll} className="h-8 text-xs rounded-full">
              {selectedSaleIds.size === sales.length ? 'Deselect All' : 'Select All'}
            </Button>
            <span className="text-xs text-muted-foreground">{selectedSaleIds.size} selected</span>
            <div className="h-5 w-px bg-muted" />
            <Input
              type="number"
              value={bulkVatRate}
              onChange={(e) => setBulkVatRate(parseFloat(e.target.value) || 0)}
              className="w-16 h-8 text-xs"
            />
            <span className="text-xs text-muted-foreground">%</span>
            <Select value={bulkVatInclusive ? 'inclusive' : 'exclusive'} onValueChange={(v) => setBulkVatInclusive(v === 'inclusive')}>
              <SelectTrigger className="h-8 w-[100px] text-xs"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="inclusive">Inclusive</SelectItem>
                <SelectItem value="exclusive">Exclusive</SelectItem>
              </SelectContent>
            </Select>
            <label className="flex items-center gap-1 text-xs text-muted-foreground cursor-pointer">
              <input
                type="checkbox"
                checked={bulkSkipExisting}
                onChange={(e) => setBulkSkipExisting(e.target.checked)}
                className="w-3.5 h-3.5 rounded"
              />
              Skip if VAT exists
            </label>
            <Button
              size="sm"
              onClick={onApply}
              disabled={selectedSaleIds.size === 0 && !bulkFilterBranch && !bulkFilterStart}
              className="h-8 text-xs rounded-full bg-teal-600 hover:bg-teal-700"
              data-testid="sales-apply-bulk-vat"
            >
              Apply VAT
            </Button>
          </>
        )}
      </div>
      {bulkVatMode && (
        <div className="flex items-center gap-2 mt-2 pl-2 flex-wrap">
          <span className="text-[10px] font-semibold text-muted-foreground uppercase">Or filter by:</span>
          <Select value={bulkFilterBranch || 'none'} onValueChange={(v) => setBulkFilterBranch(v === 'none' ? '' : v)}>
            <SelectTrigger className="h-7 w-[130px] text-[11px]"><SelectValue placeholder="Branch" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">All Branches</SelectItem>
              {branches.map(b => <SelectItem key={b.id} value={b.id}>{b.name}</SelectItem>)}
            </SelectContent>
          </Select>
          <Input type="date" value={bulkFilterStart} onChange={(e) => setBulkFilterStart(e.target.value)} className="h-7 w-[120px] text-[11px]" />
          <Input type="date" value={bulkFilterEnd} onChange={(e) => setBulkFilterEnd(e.target.value)} className="h-7 w-[120px] text-[11px]" />
          {(bulkFilterBranch || bulkFilterStart) && (
            <Button size="sm" onClick={onApply} className="h-7 text-[11px] rounded-full bg-teal-600 hover:bg-teal-700">
              Apply to Filtered
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
